import React, { useState, useEffect, useContext } from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "../SignInButton";
import { SignOutButton } from "../SignOutButton";
import './Header.css'
import { useMsal } from '@azure/msal-react';
import { Row, Col, NavDropdown } from 'react-bootstrap';
import CustomerContext from '../Auth/CustomerContext';
import AddClaimPopup from '../Claims/AddClaimPopup';
import CollectorClaimModal from '../Claims/ClaimModal/CollectorClaimModal';
import useFetch from '../Utilities/useFetch';
import { useNavigate } from 'react-router-dom';

function Header() {
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();
    const { claimNumber, setClaimNumber} = useContext(CustomerContext)
    const [newClaimFormIsOpen, setNewClaimFormIsOpen] = useState(false)
    const [claimFormIsOpen, setClaimFormIsOpen] = useState(false)
    const [hasAdminCheckResolved, setHasAdminCheckResolved] = useState(false)
    const {data: isClaimCreator} = useFetch(true,`${process.env.REACT_APP_API_URL}/Claims/isClaimCreator`,'GET')
    const {data: isAdmin} = useFetch(true,`${process.env.REACT_APP_API_URL}/Admin/IsAdmin`,'GET')
    const params = new URLSearchParams(window.location.search);
    const lowercaseParams = new URLSearchParams(
        Array.from(params, ([key, value]) => [key.toLowerCase(), value])
      );
    const paramClaimNumber = lowercaseParams.get('claimnumber')
    const navigate = useNavigate();
    let activeAccount = instance.getActiveAccount()

    useEffect(()=>{
        if(paramClaimNumber){
            setClaimNumber(paramClaimNumber)
        }
    // eslint-disable-next-line
    },[params])

    useEffect(()=>{
        if(claimNumber){
            setClaimFormIsOpen(true)
        }
    // eslint-disable-next-line
    },[claimNumber])

    useEffect(() => {
        if (isAuthenticated && isAdmin !== undefined) {
            setHasAdminCheckResolved(true);
        }
    }, [isAuthenticated, isAdmin]);
    
    const handleClaimModalClose = () => { 
        setClaimNumber(null)
        setClaimFormIsOpen(false)
        navigate('/');
     }

  return (
    <>
    {newClaimFormIsOpen&&<AddClaimPopup show={newClaimFormIsOpen} handleClose={()=>setNewClaimFormIsOpen(false)} />}
    {claimFormIsOpen&&<CollectorClaimModal show={claimFormIsOpen} setShow={handleClaimModalClose} selectedClaim={claimNumber} setSelectedClaim={setClaimNumber}/>}
    <Navbar bg="dark" variant='dark'>
        <Container>
            <Navbar.Brand href="/">RMS Staff</Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className={isAuthenticated?"navigation-wrapper":"logged-out-navigation-wrapper"}>
                    {isAuthenticated?
                    <>
                        <div className='menu-items'>
                            <NavDropdown title="Claims">
                                <NavDropdown.Item href="/Claims/OpenClaims">Claims Search</NavDropdown.Item>
                                <NavDropdown.Item href="/Claims/NCD">NCD</NavDropdown.Item>
                                {isClaimCreator&&
                                <NavDropdown.Item onClick={()=>setNewClaimFormIsOpen(true)}>Add New</NavDropdown.Item>
                            }
                            </NavDropdown>
                            <NavDropdown title="Reports">
                                <NavDropdown.Item href="/Reports/PTPReport">PTP Report</NavDropdown.Item>
                                <NavDropdown title="No Touch" className='no-touch-dropdown' drop='end'>
                                    <NavDropdown.Item title="30daylast7" href="/Reports/NoTouch/30daylast7">30 Day Last 7</NavDropdown.Item>
                                    <NavDropdown.Item title="45daylast7" href="/Reports/NoTouch/45daylast7">45 Day Last 7</NavDropdown.Item>
                                    <NavDropdown.Item title="Past30daylast14" href="/Reports/NoTouch/Past30daylast14">Past 30 Day Last 14</NavDropdown.Item>
                                    <NavDropdown.Item title="Past45daylast14" href="/Reports/NoTouch/Past45daylast14">Past 45 Day Last 14</NavDropdown.Item>
                                </NavDropdown>
                                <NavDropdown title="Arb" className='no-touch-dropdown' drop='end'>
                                    <NavDropdown.Item title="Open Unassigned" href="/Reports/Arb/Unassigned">Open Unassigned</NavDropdown.Item>
                                </NavDropdown> 
                               
                                <NavDropdown.Item href="/Reports/Performance">Staff Performance</NavDropdown.Item>
                                {isAdmin&&
                                <NavDropdown title="Executive" className='no-touch-dropdown' drop='end'>
                                    <NavDropdown.Item href="/Reports/Executive/PaymentHistory">Payment History Group</NavDropdown.Item>
                                    <NavDropdown.Item href="/Reports/CollectorNotes">Collector Notes</NavDropdown.Item>
                                    <NavDropdown.Item href="/Reports/Executive/CanClosed30Days">Can Closed 30 Days</NavDropdown.Item>    
                                    <NavDropdown.Item href="/Reports/Executive/DepositReview">Deposit Review</NavDropdown.Item>
                                </NavDropdown>
                                }
                                <NavDropdown title="Contribution" className='no-touch-dropdown' drop='end'>
                                <NavDropdown.Item href="/Reports/Contribution/PTP5Days">PTP 5 Days</NavDropdown.Item>
                                </NavDropdown>          
                                </NavDropdown>
                            {hasAdminCheckResolved && isAdmin &&
                            <NavDropdown title="Admin">
                                <NavDropdown.Item href="/Admin/Collectors">Collector Management</NavDropdown.Item>
                                <NavDropdown.Item href="/Admin/Arbitrators">Arbitrator Management</NavDropdown.Item>
                                <NavDropdown.Item href="/admin/ai-prompts">AI Prompt Management</NavDropdown.Item>
                            </NavDropdown>
                            }
                        </div>
                        <Row>
                            <Col className='login-menu-item'><SignOutButton /></Col>
                            {activeAccount&&
                            <Col className='logged-in-user-name'>
                                <p>{activeAccount.name}</p>
                            </Col>
                            }
                        </Row>
                    </>
                    :
                    <div>
                        <SignInButton />
                    </div>
                    }
            
                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>
    </>
  )
}

export default Header